import { SxProps, Theme } from '@mui/material/styles';

export const cardSx: SxProps<Theme> = {
  backgroundColor: '#1E1F25',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 1,
  '&: hover': {
    backgroundColor: '#99A8FF1A',
    cursor: 'pointer',
  },
};

export const iconWrapperSx: SxProps<Theme> = {
  backgroundColor: '#99A8FF1A',
  p: '8px',
  borderRadius: '8px',
  border: '1px solid #FFFFFF1A',
  display: 'inline-flex',
};

export const labelSx: SxProps<Theme> = {
  fontSize: 18,
  textAlign: 'center',
};
